<template>
  <div>
    <!-- 参加者リストCSV/PDFファイルの送信確認モーダル-->
    <div class="modal-box">
      <div class="modal file-confirm-modal" @click.self="$emit('close-btn-click')">
        <div class="modal-dialog">
          <!-- 送信確認表示 -->
          <div v-show="!isApiComplete">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">個人情報を含むファイルの送信確認</h5>
              </div>
              <div class="modal-body">
                <p>このイベントの全参加者ファイルを、以下の登録メールアドレス宛に送信します。</p>
                <p><span class="font-bold">送信先：</span>{{ eventer_mail }}</p>
                <div class="sentence-separator"></div>
                <p>送信メールの受信までに時間がかかる場合があります。</p>
                <p>60分以上経過してもメールが届かない場合は、 <a class="modal-link" href="https://lp.tiget.net/contact">お問い合わせフォーム</a>よりご連絡ください。</p>
                <br>
                <p>ファイルには<span class="font-bold">個人情報</span>が含まれています。秘密情報と同様に慎重に取り扱い、法令に従い適切に管理してください。</p>
                <br>
                <p><span class="font-bold">注意事項</span></p>
                <ul>
                  <li>・不要な複製や転送は行わないでください</li>
                  <li>・利用目的以外での保管・利用は控えてください</li>
                  <li>・使用後は速やかに削除してください</li>
                  <li>・第三者への共有・再配布は禁止されています</li>
                </ul>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-close" @click="$emit('close-btn-click')">キャンセル</button>
                <button type="button" class="btn btn-send" v-on:click="senAudiencesdFile">注意事項を確認の上、送信する</button>
              </div>
            </div>
          </div>
          <!-- 送信後表示 -->
          <transition key="isApiComplete-modal" appear>
            <div v-show="isApiComplete" key="isApiComplete-modal2">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">全参加者{{ file_format }}ファイルの送信</h5>
                </div>
                <div class="modal-body">
                  <p class="text-center">全参加者{{ file_format }}ファイルの送信を受け付けました。</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-close" @click="$emit('close-btn-click')">閉じる</button>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    eventer_mail: { type: String, required: true },
    main_event_title: { type: String, required: true },
    file_format: { type: String, required: true },
    send_file_api_path: { type: String, required: true },
  },
  data() {
    return {
      isApiComplete: false,
    };
  },
  methods: {
    senAudiencesdFile() {
      axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
      axios
        .get(this.send_file_api_path)
        .then((response) => {
          this.isApiComplete = true;
        })
        .catch((error) => {
          alert('エラーが発生しました。時間をおいてから改めてお試しください。');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $translucent-black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;

  .modal-content {
    padding: 30px 50px;
    z-index: 9997;

    @media screen and (max-width: $break-point) {
      padding: 25px 30px;
    }

    p {
      font-size: 15px;
    }

    .sentence-separator {
      padding: 10px;
    }

    .modal-link {
      color: #3399cc;
    }
  }
}

.file-confirm-modal {
  display: flex;

  .modal-title {
    color: #000;
    font-size: 18px;
    font-weight: bold;
  }

  .modal-header {
    border-bottom: none;
    text-align: center;
    padding-bottom: 15px;
  }

  .modal-dialog {
    width: 700px;
    max-width: 100%;
    min-height: 265px;
    margin: auto;

    @media screen and (max-width: $break-point) {
      margin: auto 30px;
      max-height: calc(100vh - 60px);
      overflow-y: auto;
    }
  }

  .modal-body {
    line-height: 21px;

    @media screen and (max-width: $break-point) {
      padding-right: 0;
      padding-left: 0;
    }

    .sending-mail-img {
      display: block;
      margin: auto;
      width: 70px;
    }
  }

  .modal-footer {
    width: 260px;
    border-top: none;
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: auto;
    padding: 15px 0 0;

    @media screen and (max-width: $break-point) {
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
    }

    .btn {
      flex-shrink: 0;
      border-radius: 4px;
      width: auto;
      height: 46px;
      font-size: 15px;
      background-color: #fff;
      margin-left: 0;
      padding: 0 30px;

      @media screen and (max-width: $break-point) {
        margin-bottom: 10px;
        padding: 0 15px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .btn-close {
      border: 1px solid $shop-lightgray;
      color: $shop-gray;
    }

    .btn-send {
      border: 1px solid $shop-blue;
      color: $shop-blue;
    }
  }
}

// アニメーション
.v-leave-active,
.v-enter-active {
  transition: opacity 0.5s;
}
.v-enter {
  opacity: 0;
}
.v-enter-to {
  opacity: 1;
}
.v-leave {
  opacity: 1;
}
.v-leave-to {
  opacity: 0;
}
</style>
